import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Guides from "../pages/guides/page";
import GuideDetail from "../pages/guide-detail/page";
import Resources from "../pages/resources/page";
import Contact from "../pages/contact/page";
import FallFestivals from '../pages/fall-festivals/page';
import FestivalDetail from '../pages/festival-detail/page';
import HolidaySeason from '../pages/holiday-season/page';
import HolidayDetail from '../pages/holiday-detail/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/guides',
    element: <Guides />,
  },
  {
    path: '/guide-detail/:id',
    element: <GuideDetail />,
  },
  {
    path: '/holiday-season',
    element: <HolidaySeason />,
  },
  {
    path: '/holiday-detail/:id',
    element: <HolidayDetail />,
  },
  {
    path: '/fall-festivals',
    element: <FallFestivals />,
  },
  {
    path: '/festival-detail/:id',
    element: <FestivalDetail />,
  },
  {
    path: '/resources',
    element: <Resources />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
